import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import FreelancerLayout from "../../layouts/FreelancerLayout";
import { fetchfreelancerProfile } from "../../redux/features/find-a-job/actions/authAction";
import Loader from "../../components/loader";
import { getProfile } from "../../utils/pip";
const MyCourses = () => {
const { subLoading } = useSelector((state) => state.freelancer.auth);
if (subLoading) {
return 
<Loader />
;
}
return (
<div>
   <FreelancerLayout>
      <div className="ct_px_40 my-5">
         <div className="container-fluid">
            <div className="row gx-5">
               <div className="col-xxl-9 col-xl-8 col-lg-8 mb-4">
                  <div class="ct_outline_bg ct_p_10 ct_box_shadow_card_1">
                     <h4 class="ct_fs_20  ct_mb_30">Upcoming Event</h4>
                     <div class="row">
                        <div class="col-md-12">
                           <div class="owl-carousel owl-theme ct_upcoming_slider2">
                              <div class="item">
                                 <figure class="ct_upcomming_card">
                                    <div class="ct_upcomming_event_img">
                                       <img src="../assets/img/event_img_1.jpg" alt="" />
                                    </div>
                                    <figcaption>
                                       <h6 className="ct_fs_16 ct_darkblue_text">
                                          CSS Beginners
                                       </h6>
                                       <p class="mb-0 ct_fs_12 ct_grey_text">Today, 12:00 PM - 15:00 PM</p>
                                    </figcaption>
                                 </figure>
                              </div>
                              <div class="item">
                                 <figure class="ct_upcomming_card">
                                    <div class="ct_upcomming_event_img">
                                       <img src="../assets/img/event_img_2.jpg" alt="" />
                                    </div>
                                    <figcaption>
                                       <h6 className="ct_fs_16 ct_darkblue_text">
                                          UI/UX Design Beginners
                                       </h6>
                                       <p class="mb-0 ct_fs_12 ct_grey_text">Today, 16:00 PM - 17:00 PM</p>
                                    </figcaption>
                                 </figure>
                              </div>
                              <div class="item">
                                 <figure class="ct_upcomming_card">
                                    <div class="ct_upcomming_event_img">
                                       <img src="../assets/img/event_img_3.jpg" alt="" />
                                    </div>
                                    <figcaption>
                                       <h6 className="ct_fs_16 ct_darkblue_text">
                                          UI/UX Design Beginners
                                       </h6>
                                       <p class="mb-0 ct_fs_12 ct_grey_text">Today, 16:00 PM - 17:00 PM</p>
                                    </figcaption>
                                 </figure>
                              </div>
                              <div class="item">
                                 <figure class="ct_upcomming_card">
                                    <div class="ct_upcomming_event_img">
                                       <img src="../assets/img/event_img_2.jpg" alt="" />
                                    </div>
                                    <figcaption>
                                       <h6 className="ct_fs_16 ct_darkblue_text">
                                          UI/UX Design Beginners
                                       </h6>
                                       <p class="mb-0 ct_fs_12 ct_grey_text">Today, 16:00 PM - 17:00 PM</p>
                                    </figcaption>
                                 </figure>
                              </div>
                              <div class="item">
                                 <figure class="ct_upcomming_card">
                                    <div class="ct_upcomming_event_img">
                                       <img src="../assets/img/event_img_2.jpg" alt="" />
                                    </div>
                                    <figcaption>
                                       <h6 className="ct_fs_16 ct_darkblue_text">
                                          UI/UX Design Beginners
                                       </h6>
                                       <p class="mb-0 ct_fs_12 ct_grey_text">Today, 16:00 PM - 17:00 PM</p>
                                    </figcaption>
                                 </figure>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                   <div class="ct_outline_bg ct_p_10 ct_box_shadow_card_1 ct_mt_30">
                        <h4 class="ct_fs_20  ct_mb_30">Course in Progress</h4>
                         <div className="ct_job_apply_list_main ct_mt_30 ">
                    <ul>
                      <li>
                        <div className="d-flex align-items-center gap-4 ct_flex_col_575">
                            <img src="../assets/img/course_img_3.png" className="ct_img_w_120"/>
                            <div className="ct_flex_1">
                                <h4 className="ct_fs_16 ct_darkblue_text ct_mb_16">UI/UX Design Beginners</h4>
                                <p className="ct_grey_text mb-0"><span className="ct_yellow_text">8</span> of 16 course progress</p>
                              <div class="progress ct_custom_progress ct_mt_20">
                            <div class="progress-bar w-75" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            </div>
                        </div>
                      </li>
                       <li className="mt-4 active">
                        <div className="d-flex align-items-center gap-4 ct_flex_col_575">
                            <img src="../assets/img/course_img_2.png" className="ct_img_w_120"/>
                            <div className="ct_flex_1">
                                <h4 className="ct_fs_16 ct_darkblue_text ct_mb_16">UI/UX Design Beginners</h4>
                                <p className="ct_grey_text mb-0"><span className="ct_yellow_text">8</span> of 16 course progress</p>
                              <div class="progress ct_custom_progress ct_mt_20">
                            <div class="progress-bar w-75" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            </div>
                        </div>
                      </li>
                       <li className="mt-4 ">
                        <div className="d-flex align-items-center gap-4 ct_flex_col_575">
                            <img src="../assets/img/course_img_1.png" className="ct_img_w_120"/>
                            <div className="ct_flex_1">
                                <h4 className="ct_fs_16 ct_darkblue_text ct_mb_16">UI/UX Design Beginners</h4>
                                <p className="ct_grey_text mb-0"><span className="ct_yellow_text">8</span> of 16 course progress</p>
                              <div class="progress ct_custom_progress ct_mt_20">
                            <div class="progress-bar w-75" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            </div>
                        </div>
                      </li>
                     
                     
                    
                    </ul>
                  </div>
                   </div>
                      <div class="ct_outline_bg ct_p_10 ct_box_shadow_card_1 ct_mt_30">
                        <div className="d-flex align-items-center justify-content-between gap-3 ct_mb_30">
                            <h5 className="ct_fs_20 ct_darkblue_text mb-0">Course Recommendations</h5>
                            <a className="ct_dark_blue_link ct_fs_16">View All</a>

                        </div>
                        <div className="row">
                            <div className="col-lg-4 col-md-6 ct_mb_30">
                                <figure className="ct_course_card">
                                    <img src="../assets/img/course_recomend_img_1.png"/>
                                    <figcaption>
                                        <h6 className="ct_fs_16 ct_mb_16">Graphic Design</h6>
                                        <div className="d-flex align-items-center gap-2">
                                            <i class="fa-solid fa-star ct_orange_text"></i>
                                            <i class="fa-solid fa-star ct_orange_text"></i>
                                            <i class="fa-solid fa-star ct_orange_text"></i>
                                            <i class="fa-solid fa-star ct_orange_text"></i>
                                            <i class="fa-solid fa-star ct_orange_text"></i>

                                        </div>
                                        <div className="d-flex align-items-center gap-2 ct_mt_20">
                                            <img src="../assets/img/user_34.png" className="ct_img_30"/>
                                            <h6 className="mb-0 ct_fs_14 ct_darkblue_text">Arthur Taylor</h6>
                                        </div>
                                    </figcaption>
                                </figure>

                            </div>
                            <div className="col-lg-4 col-md-6 ct_mb_30">
                                <figure className="ct_course_card">
                                    <img src="../assets/img/course_recomend_img_2.png"/>
                                    <figcaption>
                                        <h6 className="ct_fs_16 ct_mb_16">Graphic Design</h6>
                                        <div className="d-flex align-items-center gap-2">
                                            <i class="fa-solid fa-star ct_orange_text"></i>
                                            <i class="fa-solid fa-star ct_orange_text"></i>
                                            <i class="fa-solid fa-star ct_orange_text"></i>
                                            <i class="fa-solid fa-star ct_orange_text"></i>
                                            <i class="fa-solid fa-star ct_orange_text"></i>

                                        </div>
                                        <div className="d-flex align-items-center gap-2 ct_mt_20">
                                            <img src="../assets/img/user_34.png" className="ct_img_30"/>
                                            <h6 className="mb-0 ct_fs_14 ct_darkblue_text">Steven Scot</h6>
                                        </div>
                                    </figcaption>
                                </figure>

                            </div>
                              <div className="col-lg-4 col-md-6 ct_mb_30">
                                <figure className="ct_course_card">
                                    <img src="../assets/img/course_recomend_img_3.png"/>
                                    <figcaption>
                                        <h6 className="ct_fs_16 ct_mb_16">Graphic Design</h6>
                                        <div className="d-flex align-items-center gap-2">
                                            <i class="fa-solid fa-star ct_orange_text"></i>
                                            <i class="fa-solid fa-star ct_orange_text"></i>
                                            <i class="fa-solid fa-star ct_orange_text"></i>
                                            <i class="fa-solid fa-star ct_orange_text"></i>
                                            <i class="fa-solid fa-star ct_orange_text"></i>

                                        </div>
                                        <div className="d-flex align-items-center gap-2 ct_mt_20">
                                            <img src="../assets/img/user_34.png" className="ct_img_30"/>
                                            <h6 className="mb-0 ct_fs_14 ct_darkblue_text">Arthur Taylor</h6>
                                        </div>
                                    </figcaption>
                                </figure>

                            </div>
                             <div className="col-lg-4 col-md-6 ct_mb_30">
                                <figure className="ct_course_card">
                                    <img src="../assets/img/course_recomend_img_4.png"/>
                                    <figcaption>
                                        <h6 className="ct_fs_16 ct_mb_16">Graphic Design</h6>
                                        <div className="d-flex align-items-center gap-2">
                                            <i class="fa-solid fa-star ct_orange_text"></i>
                                            <i class="fa-solid fa-star ct_orange_text"></i>
                                            <i class="fa-solid fa-star ct_orange_text"></i>
                                            <i class="fa-solid fa-star ct_orange_text"></i>
                                            <i class="fa-solid fa-star ct_orange_text"></i>

                                        </div>
                                        <div className="d-flex align-items-center gap-2 ct_mt_20">
                                            <img src="../assets/img/user_34.png" className="ct_img_30"/>
                                            <h6 className="mb-0 ct_fs_14 ct_darkblue_text">Arthur Taylor</h6>
                                        </div>
                                    </figcaption>
                                </figure>

                            </div>
                             <div className="col-lg-4 col-md-6 ct_mb_30">
                                <figure className="ct_course_card">
                                    <img src="../assets/img/course_recomend_img_5.png"/>
                                    <figcaption>
                                        <h6 className="ct_fs_16 ct_mb_16">Graphic Design</h6>
                                        <div className="d-flex align-items-center gap-2">
                                            <i class="fa-solid fa-star ct_orange_text"></i>
                                            <i class="fa-solid fa-star ct_orange_text"></i>
                                            <i class="fa-solid fa-star ct_orange_text"></i>
                                            <i class="fa-solid fa-star ct_orange_text"></i>
                                            <i class="fa-solid fa-star ct_orange_text"></i>

                                        </div>
                                        <div className="d-flex align-items-center gap-2 ct_mt_20">
                                            <img src="../assets/img/user_34.png" className="ct_img_30"/>
                                            <h6 className="mb-0 ct_fs_14 ct_darkblue_text">Arthur Taylor</h6>
                                        </div>
                                    </figcaption>
                                </figure>

                            </div>
                             <div className="col-lg-4 col-md-6 ct_mb_30">
                                <figure className="ct_course_card">
                                    <img src="../assets/img/course_recomend_img_6.png"/>
                                    <figcaption>
                                        <h6 className="ct_fs_16 ct_mb_16">Graphic Design</h6>
                                        <div className="d-flex align-items-center gap-2">
                                            <i class="fa-solid fa-star ct_orange_text"></i>
                                            <i class="fa-solid fa-star ct_orange_text"></i>
                                            <i class="fa-solid fa-star ct_orange_text"></i>
                                            <i class="fa-solid fa-star ct_orange_text"></i>
                                            <i class="fa-solid fa-star ct_orange_text"></i>

                                        </div>
                                        <div className="d-flex align-items-center gap-2 ct_mt_20">
                                            <img src="../assets/img/user_34.png" className="ct_img_30"/>
                                            <h6 className="mb-0 ct_fs_14 ct_darkblue_text">Arthur Taylor</h6>
                                        </div>
                                    </figcaption>
                                </figure>

                            </div>

                        </div>
                      </div>
               </div>
               <div className="col-xxl-3 col-xl-4 col-lg-4 mb-4">
                  <div>
               
                <div className="">
                    <div className="ct_outline_bg h-100 ct_py_20_px_10 ct_border_radius_10 ct_box_shadow_card_1">Calander</div>
                  <div className="ct_outline_bg h-100 ct_py_20_px_10 ct_border_radius_10 ct_box_shadow_card_1 ct_mt_30">
                   <div>
                     <p className="ct_fs_20 mb-1 ct_darkblue_text">
                      Upcoming task 
                    </p>
                    <p className="mb-0 ct_fs_14 ct_grey_text">Friday, 24 July 2025</p>
                   </div>
                    <ul className="ct_mt_30">
                      <li>
                        <div class="course-card">
                          <div>
                            <h6 class="ct_fs_16 ct_mb_16">Alex Workshop </h6>
                            <p className="ct_fs_14 ct_grey_text mb-0">09:00 AM - 11:30 AM</p>
                         
                          </div>

                          <div class="progress-circle progress-circle_orange">
                            <span>75%</span>
                          </div>
                        </div>
                      </li>
                      <li className="mt-3">
                        <div
                          class="course-card"
                          style={{
                            backgroundColor: "hsl(199deg 64% 73% / 5%)",
                          }}
                        >
                         <div>
                            <h6 class="ct_fs_16 ct_mb_16">Alex Webinars</h6>
                            <p className="ct_fs_14 ct_grey_text mb-0">12:00PM - 2:00 PM</p>
                         
                          </div>

                          <div class="progress-circle progress-circle_lightsky">
                            <span>75%</span>
                          </div>
                        </div>
                      </li>
                      <li className="mt-3">
                        <div class="course-card">
                           <div>
                            <h6 class="ct_fs_16 ct_mb_16">Course Progress</h6>
                            <p className="ct_fs_14 ct_grey_text mb-0">6 Completed</p>
                         
                          </div>

                          <div class="progress-circle progress-circle_yellow">
                            <span>75%</span>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                    <div className="ct_outline_bg h-100 ct_py_20_px_10 ct_border_radius_10 ct_box_shadow_card_1 ct_mt_30">
                         <div className="d-flex align-items-center justify-content-between gap-3 ct_mb_30">
                            <h5 className="ct_fs_20 ct_darkblue_text mb-0">Messages</h5>
                            <a className="ct_dark_blue_link ct_fs_16">View All</a>
                        </div>

                          <div class="chat-list ct_chatt_list_right_sidear_scroll ct_custom_scroll">
                        <a href="javascript:void(0)" class="d-flex">
                          <div class="ct_chat_list_grid">
                            <div class="position-relative">
                              <img
                                class="img-fluid ct_img_40"
                                src="../assets/img/chat_user.png"
                                alt="user img"
                              />
                            </div>
                            <div class="flex-grow-1 ms-3">
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <div>
                                  <h3 class="ct_fs_16 mb-0 ct_darkblue_text">
                                    Evelyn Shu
                                  </h3>
                                  <p className="ct_fs_12 ct_text_clr_9A96A4 text-truncate" style={{width:"150px"}}>
                                   So, You need to rewatch lessons?
                                  </p>
                                </div>
                                <div className="text-center ms-auto">
                                  <p className="mb-0 ct_text_clr_9A96A4 ct_white_nowrap">
                                    23min
                                  </p>
                                  <div class="ct_caht_msg_notify mt-1  ">
                                    <span class="mx-auto">1</span>
                                  </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </a>
                       <a href="javascript:void(0)" class="d-flex">
                          <div class="ct_chat_list_grid">
                            <div class="position-relative">
                              <img
                                class="img-fluid ct_img_40"
                                src="../assets/img/chat_user.png"
                                alt="user img"
                              />
                            </div>
                            <div class="flex-grow-1 ms-3">
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <div>
                                  <h3 class="ct_fs_16 mb-0 ct_darkblue_text">
                                    Evelyn Shu
                                  </h3>
                                  <p className="ct_fs_12 ct_text_clr_9A96A4 text-truncate" style={{width:"150px"}}>
                                   So, You need to rewatch lessons?
                                  </p>
                                </div>
                                <div className="text-center ms-auto">
                                  <p className="mb-0 ct_text_clr_9A96A4 ct_white_nowrap">
                                    23min
                                  </p>
                                  <div class="ct_caht_msg_notify mt-1  ">
                                    <span class="mx-auto">1</span>
                                  </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </a>
                        <a href="javascript:void(0)" class="d-flex">
                          <div class="ct_chat_list_grid">
                            <div class="position-relative">
                              <img
                                class="img-fluid ct_img_40"
                                src="../assets/img/chat_user.png"
                                alt="user img"
                              />
                            </div>
                            <div class="flex-grow-1 ms-3">
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <div>
                                  <h3 class="ct_fs_16 mb-0 ct_darkblue_text">
                                    Evelyn Shu
                                  </h3>
                                  <p className="ct_fs_12 ct_text_clr_9A96A4 text-truncate" style={{width:"150px"}}>
                                   So, You need to rewatch lessons?
                                  </p>
                                </div>
                                <div className="text-center ms-auto">
                                  <p className="mb-0 ct_text_clr_9A96A4 ct_white_nowrap">
                                    23min
                                  </p>
                                  <div class="ct_caht_msg_notify mt-1  ">
                                    <span class="mx-auto">1</span>
                                  </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </a>
                        <a href="javascript:void(0)" class="d-flex">
                          <div class="ct_chat_list_grid">
                            <div class="position-relative">
                              <img
                                class="img-fluid ct_img_40"
                                src="../assets/img/chat_user.png"
                                alt="user img"
                              />
                            </div>
                            <div class="flex-grow-1 ms-3">
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <div>
                                  <h3 class="ct_fs_16 mb-0 ct_darkblue_text">
                                    Evelyn Shu
                                  </h3>
                                  <p className="ct_fs_12 ct_text_clr_9A96A4 text-truncate" style={{width:"150px"}}>
                                   So, You need to rewatch lessons?
                                  </p>
                                </div>
                                <div className="text-center ms-auto">
                                  <p className="mb-0 ct_text_clr_9A96A4 ct_white_nowrap">
                                    23min
                                  </p>
                                  <div class="ct_caht_msg_notify mt-1  ">
                                    <span class="mx-auto">1</span>
                                  </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </a>
                        <a href="javascript:void(0)" class="d-flex">
                          <div class="ct_chat_list_grid">
                            <div class="position-relative">
                              <img
                                class="img-fluid ct_img_40"
                                src="../assets/img/chat_user.png"
                                alt="user img"
                              />
                            </div>
                            <div class="flex-grow-1 ms-3">
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <div>
                                  <h3 class="ct_fs_16 mb-0 ct_darkblue_text">
                                    Evelyn Shu
                                  </h3>
                                  <p className="ct_fs_12 ct_text_clr_9A96A4 text-truncate" style={{width:"150px"}}>
                                   So, You need to rewatch lessons?
                                  </p>
                                </div>
                                <div className="text-center ms-auto">
                                  <p className="mb-0 ct_text_clr_9A96A4 ct_white_nowrap">
                                    23min
                                  </p>
                                  <div class="ct_caht_msg_notify mt-1  ">
                                    <span class="mx-auto">1</span>
                                  </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </a>
                        <a href="javascript:void(0)" class="d-flex">
                          <div class="ct_chat_list_grid">
                            <div class="position-relative">
                              <img
                                class="img-fluid ct_img_40"
                                src="../assets/img/chat_user.png"
                                alt="user img"
                              />
                            </div>
                            <div class="flex-grow-1 ms-3">
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <div>
                                  <h3 class="ct_fs_16 mb-0 ct_darkblue_text">
                                    Evelyn Shu
                                  </h3>
                                  <p className="ct_fs_12 ct_text_clr_9A96A4 text-truncate" style={{width:"150px"}}>
                                   So, You need to rewatch lessons?
                                  </p>
                                </div>
                                <div className="text-center ms-auto">
                                  <p className="mb-0 ct_text_clr_9A96A4 ct_white_nowrap">
                                    23min
                                  </p>
                                  <div class="ct_caht_msg_notify mt-1  ">
                                    <span class="mx-auto">1</span>
                                  </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </a>
                        <a href="javascript:void(0)" class="d-flex">
                          <div class="ct_chat_list_grid">
                            <div class="position-relative">
                              <img
                                class="img-fluid ct_img_40"
                                src="../assets/img/chat_user.png"
                                alt="user img"
                              />
                            </div>
                            <div class="flex-grow-1 ms-3">
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <div>
                                  <h3 class="ct_fs_16 mb-0 ct_darkblue_text">
                                    Evelyn Shu
                                  </h3>
                                  <p className="ct_fs_12 ct_text_clr_9A96A4 text-truncate" style={{width:"150px"}}>
                                   So, You need to rewatch lessons?
                                  </p>
                                </div>
                                <div className="text-center ms-auto">
                                  <p className="mb-0 ct_text_clr_9A96A4 ct_white_nowrap">
                                    23min
                                  </p>
                                  <div class="ct_caht_msg_notify mt-1  ">
                                    <span class="mx-auto">1</span>
                                  </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </a>
                      </div>
                                         
                    </div>
                </div>
              </div>
               </div>
            </div>
         </div>
      </div>
   </FreelancerLayout>
</div>
)
}
export default MyCourses